<template>
  <div class="flex-box">
    <div class="search-box">
      <div>
        <label class="searchItemName">渠道：</label>
        <el-select v-model="queryParams.channelId" clearable placeholder="筛选渠道">
          <el-option v-for="item in channels" :key="item.id" :label="item.channelName" :value="item.id"></el-option>
        </el-select>
      </div>
      <div>
        <label class="searchItemName">统计日期：</label>
        <el-date-picker v-model="queryParams.dateRange" type="daterange" value-format="yyyy-MM-dd"
          start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels
          :picker-options="pickerOptions"></el-date-picker>
      </div>
      <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">查询</el-button>
      <el-button type="primary" icon="el-icon-download" @click="ExportTable()">下载统计数据</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%; margin: 15px 0;">
      <el-table-column prop="deviceCode" label="设备编号" width="140" align="center"></el-table-column>
      <el-table-column prop="channelName" label="渠道" width="160" align="center"></el-table-column>
      <el-table-column prop="address" label="投放地址" min-width="180" align="center"></el-table-column>
      <el-table-column prop="photoCount" label="拍照次数" width="110" align="center"></el-table-column>
      <el-table-column prop="payCount" label="支付笔数" width="110" align="center"></el-table-column>
      <el-table-column label="支付金额" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.amountTotal) }}</template>
      </el-table-column>
      <el-table-column prop="refundCount" label="退款笔数" width="110" align="center"></el-table-column>
      <el-table-column label="退款金额" width="120" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.refundAmount) }}</template>
      </el-table-column>
    </el-table>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="queryParams.pageIndex" :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import listPage from '../../../mixins/listPage.js'
import { post } from '../../../../public/request/request.js'
import Excel from '../../../../public/tools/exportExcelHelp.js'

function formatDay(date) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function defaultDeviceRange() {
  const end = new Date()
  const start = new Date()
  start.setMonth(start.getMonth() - 1)
  return [formatDay(start), formatDay(end)]
}

export default {
  mixins: [listPage],
  data() {
    return {
      total: 0,
      channels: [],
      queryParams: { pageIndex: 1, pageSize: 10, channelId: '', dateRange: defaultDeviceRange() },
      tableData: [],
      pickStart: null,
      pickerOptions: {
        onPick: ({ minDate, maxDate }) => {
          this.pickStart = maxDate ? null : minDate
        },
        disabledDate: (time) => {
          if (!this.pickStart) return false
          const start = new Date(this.pickStart)
          const min = new Date(start)
          min.setMonth(min.getMonth() - 24)
          const max = new Date(start)
          max.setMonth(max.getMonth() + 24)
          return time.getTime() < min.getTime() || time.getTime() > max.getTime()
        }
      }
    }
  },
  created() {
    this.loadChannels()
    this.GetData()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.GetData()
    },
    loadChannels() {
      post(208, { channelName: '' }).then(response => {
        if (response.data.result == 0 && Array.isArray(response.data.data)) {
          this.channels = response.data.data
        }
      }).catch(() => {})
    },
    GetData() {
      const range = this.queryParams.dateRange || []
      if (!range[0] || !range[1]) {
        this.$message.warning('请选择统计日期，最长跨度24个月')
        return
      }
      const loading = this.openLoading()
      post(603, {
        pageIndex: this.queryParams.pageIndex,
        pageSize: this.queryParams.pageSize,
        channelId: this.queryParams.channelId || 0,
        beginTime: range[0],
        endTime: range[1]
      }).then(response => {
        loading.close()
        if (response.data.result == 0) {
          const data = response.data.data || {}
          this.tableData = Array.isArray(data.list) ? data.list : []
          this.total = Number(data.pageCount) || 0
        } else {
          this.tableData = []
          this.total = 0
          this.$message.error('查询失败：' + response.data.message)
        }
      }).catch(error => {
        loading.close()
        this.tableData = []
        this.total = 0
        this.$message.error((error && error.userMessage) || '查询失败')
      })
    },
    fetchAllDevices() {
      const range = this.queryParams.dateRange || []
      const pageSize = 200
      const loadPage = (pageIndex, collected) => {
        return post(603, {
          pageIndex,
          pageSize,
          channelId: this.queryParams.channelId || 0,
          beginTime: range[0],
          endTime: range[1]
        }).then(response => {
          if (response.data.result != 0) {
            return Promise.reject(new Error(response.data.message || '查询失败'))
          }
          const data = response.data.data || {}
          const list = Array.isArray(data.list) ? data.list : []
          const next = collected.concat(list)
          const pageCount = Number(data.pageCount) || next.length
          if (next.length < pageCount && list.length > 0) {
            return loadPage(pageIndex + 1, next)
          }
          return next
        })
      }
      return loadPage(1, [])
    },
    ExportTable() {
      const range = this.queryParams.dateRange || []
      if (!range[0] || !range[1]) {
        this.$message.warning('请选择统计日期后再导出')
        return
      }
      const loading = this.openLoading()
      this.fetchAllDevices().then(list => {
        loading.close()
        if (!list.length) {
          this.$message.warning('没有可导出的数据')
          return
        }
        const rows = list.map(item => Object.assign({
          '设备编号': item.deviceCode,
          '渠道': item.channelName,
          '投放地址': item.address
        }, Excel.metricFields(item)))
        rows.push(Object.assign({
          '设备编号': '合计',
          '渠道': '',
          '投放地址': ''
        }, Excel.metricTotal(list)))
        Excel.ExportExcel(rows, Excel.fileName('设备统计', range[0], range[1]))
        this.$message.success('导出成功')
      }).catch(error => {
        loading.close()
        this.$message.error((error && error.message) || (error && error.userMessage) || '导出失败')
      })
    }
  }
}
</script>
